import { DialogRootProps } from '@chakra-ui/react';

/**
 * `onRequestDismiss` for modals and drawers: ignore zag's dismiss cascade.
 *
 * zag dismisses every layer registered after one that is removed, and that
 * cascade skips `closeOnInteractOutside`. A select or menu item that opens a
 * dialog closes its popover in the same batch, so when the dialog's layer
 * registered first, the popover's removal closed the brand-new dialog (the
 * quote header's "+ New Contact"). v2 had no such cascade, and our dialogs are
 * controlled by their open prop. zag calls `onRequestDismiss` only from this
 * cascade, so Escape, outside clicks and close buttons still close them.
 */
export const ignoreParentLayerDismiss: DialogRootProps['onRequestDismiss'] = (
  event,
) => {
  event.preventDefault();
};
